import React, { Component, Fragment } from 'react'
import { makeObservable, observable } from 'mobx'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'
import { cloneDeep } from 'lodash'

import Panel from '../../UniformComponents/Panel'
import SkipOption from './SkipOption'
import Select from '../form/Select'
import SkipPageOption from './SkipPageOption'
import Button from '../../UniformComponents/Button'
import SkipLogic from '../../Models/SkipLogic'
import Modal from '../../UniformComponents/Modal'
import ModalHeader from '../../UniformComponents/ModalHeader'

import './styles/skipDisplayLogic.scss'
import { SkipLogicOperators } from '../../Models/SkipLogicHelpers'
import CogIcon from '../../assets/images/skiplogic_cog.svg'
import PlusIcon from '../../assets/images/skiplogic_plus.svg'

const SkipSelection = observer((props) => {
    const {
        removeSkipGroup,
        changeTriggerOperator,
        store,
        changeSkipGroup,
        index,
        id,
        group,
        origQuestion,
        activeGroupIndex,
        updateTriggerGroupOperator,
    } = props

    const changeGroupTriggerOperator = (obj, childIndex) => {
        const { value } = obj

        updateTriggerGroupOperator(index, childIndex, value)
    }

    const h = group.children.map((child, i) => {
        const id = `skipChild${i}`
        return (
            <Fragment>
                <div style={{ position: 'relative' }}>
                    {i > 0 && (
                        <div className="trigger-group">
                            <Select
                                classNamePrefix="dropdown"
                                className="exploriDropdown"
                                label={i18n.t('skipLogicModal.function')}
                                defaultValue={child.interGroupLogicalOperator}
                                options={SkipLogicOperators}
                                onBlur={(obj) => changeGroupTriggerOperator(obj, i)}
                            />
                        </div>
                    )}

                    <SkipPageOption
                        store={store}
                        key={id}
                        group={child}
                        index={i}
                        removeTrigger={(ind, e) => {
                            group.removeChild(ind, e)
                            store.handleUnsavedSkipLogicChanges()
                        }}
                        changeTriggerOperator={changeTriggerOperator}
                        triggerIndex={index}
                        origQuestion={origQuestion}
                    />
                </div>
            </Fragment>
        )
    })

    return (
        <Fragment>
            {h.length === 0
                ? (
                    <div
                        onClick={() => changeSkipGroup(index)}
                        className={`no-options-section ${activeGroupIndex === index ? 'selected-group' : ''}`}
                    >
                        <img src={index === 0 ? CogIcon : PlusIcon} />

                        {index === 0
                            ? (
                                <Fragment>
                                    <p style={{ fontWeight: 'bold' }}>{i18n.t('skipLogicModal.noOptions')}</p>

                                    <p>{i18n.t('skipLogicModal.noOptions2')}</p>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <p>{i18n.t('skipLogicModal.newOptions')}</p>

                                    <p className="option-highlight">{i18n.t('skipLogicModal.newOptions2')}</p>

                                    <div
                                        className="no-option-delete"
                                        onClick={(e) => removeSkipGroup(index, e)}
                                    >
                                        <i className="fal fa-circle-xmark" />

                                        <p>{i18n.t('delete')}</p>
                                    </div>
                                </Fragment>
                            )}
                    </div>
                )
                : (
                    <div id={id} className={`skip-logic-group ${activeGroupIndex === index ? 'selected-group' : ''}`}>
                        <div onClick={() => changeSkipGroup(index)}>
                            {h}
                        </div>

                        <div style={{ padding: 10, backgroundColor: 'white', borderBottomLeftRadius: 6, borderBottomRightRadius: 6 }}>
                            <div
                                style={{ color: 'red', cursor: 'pointer', gap: 5, display: 'flex', alignItems: 'center' }}
                                onClick={(e) => removeSkipGroup(index, e)}
                            >
                                <i className="fal fa-circle-xmark" />

                                <p>{i18n.t('delete')}</p>
                            </div>
                        </div>
                    </div>
                )}
        </Fragment>
    )
})

@observer
class SkipDisplayLogic extends Component {
    @observable showOptions = observable.map({})

    @observable activeGroupIndex = 0

    @observable prevPagesOpen = false

    @observable otherValuesOpen = false

    @observable skipLogic

    @observable hadExistingLogic = false

    @observable deleteAllModalOpen = false

    @observable saving = false

    questionLogic = []

    optionIndex

    constructor(props) {
        super(props)
        makeObservable(this)
        this.addSkipGroup = this.addSkipGroup.bind(this)
    }

    componentWillMount() {
        const { pages, store } = this.props
        const { skipLogicConfig, survey } = store
        const { page } = skipLogicConfig

        if (skipLogicConfig.type === 'option') {
            this.getQuestionOptionLogic()
        }

        if (skipLogicConfig.type === 'question') {
            const existingLogic = survey.skipLogic.find((logic) => (
                logic.action.kind === 'ShowQuestion' && logic.action.pageQuestionId === skipLogicConfig.question.id
            ))

            if (!existingLogic) {
                this.skipLogic = this.getDefaultQuestionLogic()
            } else {
                this.hadExistingLogic = true
                this.skipLogic = existingLogic
            }
        }

        if (skipLogicConfig.type === 'page') {
            const existingLogic = survey.skipLogic.find((logic) => (
                logic.action.kind === 'ShowPage' && logic.action.pageId === page.id
            ))

            if (!existingLogic) {
                this.skipLogic = this.getDefaultPageLogic()
            } else {
                this.hadExistingLogic = true
                this.skipLogic = existingLogic
            }
        }

        console.log(`skiplogic = ${JSON.stringify(this.skipLogic)}`)
        pages.forEach((page, index) => {
            this.showOptions.set(index, false)
        })
    }

    componentDidUpdate() {
        if (this.skipLogic.triggerGroups.length > 1 && !this.skipLogic.triggerGroups[0].children.length) {
            this.skipLogic.triggerGroups.splice(0, 1)
            this.activeGroupIndex = 0
        }
    }

    getQuestionOptionLogic = () => {
        const { store } = this.props
        const { skipLogicConfig } = store

        this.questionLogic = skipLogicConfig.question.skipLogic

        const existingLogic = skipLogicConfig.question.skipLogic.find((logic, index) => {
            if (logic.action.kind === 'ShowQuestionOption' && logic.action.optionId === skipLogicConfig.option.id) {
                this.optionIndex = index
                return logic
            }
        })
        store.previousSkipLogic = cloneDeep(skipLogicConfig.question.skipLogic)

        if (!existingLogic) {
            this.skipLogic = this.getDefaultOptionLogic()
        } else {
            this.hadExistingLogic = true
            this.skipLogic = existingLogic
        }
    }

    openDeleteAllModal = () => {
        this.deleteAllModalOpen = true
    }

    closeDeleteAllModal = () => {
        this.deleteAllModalOpen = false
    }

    getDefaultPageLogic = () => {
        const { store } = this.props

        return new SkipLogic({
            action: {
                kind: 'ShowPage',
                pageId: store.skipLogicConfig.page.id,
            },
            triggerGroups: [{
                children: [],
                interGroupLogicalOperator: 'OR',
            }],
        }, store)
    }

    getDefaultQuestionLogic = () => {
        const { store } = this.props

        return new SkipLogic({
            action: {
                kind: 'ShowQuestion',
                pageQuestionId: store.skipLogicConfig.question.id,
            },
            triggerGroups: [{
                children: [],
                interGroupLogicalOperator: 'OR',
            }],
        }, store)
    }

    getDefaultOptionLogic = () => {
        const { store } = this.props

        return new SkipLogic({
            action: {
                kind: 'ShowQuestionOption',
                optionId: store.skipLogicConfig.option.id,
                pageQuestionId: store.skipLogicConfig.question.id,
            },
            triggerGroups: [{
                children: [],
                interGroupLogicalOperator: 'OR',
            }],
            id: uuidv4(),
        }, store)
    }

    setDefaultLogic = () => {
        const { store } = this.props
        switch (store.skipLogicConfig.type) {
            case 'option':
                this.skipLogic = this.getDefaultOptionLogic()
                break
            case 'question':
                this.skipLogic = this.getDefaultQuestionLogic()
                break
            case 'page':
                this.skipLogic = this.getDefaultPageLogic()
                break
            default:
                break
        }
    }

    save = async (page, survey) => {
        const { store } = this.props
        const { skipLogic } = this
        const { skipLogicConfig } = store
        this.saving = true

        try {
            if (skipLogicConfig.onSave) {
                const containsEmptyTriggerGroups = skipLogic.triggerGroups
                    .filter((group) => group.children.length === 0).length
                if (containsEmptyTriggerGroups) {
                    skipLogic.triggerGroups = skipLogic.triggerGroups.filter((group) => group.children.length !== 0)

                    if (!skipLogic.triggerGroups.length) {
                        this.questionLogic = []
                    } else {
                        this.questionLogic = [skipLogic]
                    }
                    this.optionIndex = undefined
                } else if (this.optionIndex === undefined) {
                    this.questionLogic.push(skipLogic)
                } else {
                    this.questionLogic[this.optionIndex] = skipLogic
                    this.getQuestionOptionLogic()
                }

                await skipLogicConfig.onSave(store, this.questionLogic)
                await store.handleSaveSkipLogicChanges()
                return
            }

            const hasChildren = skipLogic.triggerGroups
                .some((triggerGroup) => triggerGroup.children.length > 0)

            if (!hasChildren) {
                if (skipLogic.id) {
                    await skipLogic.remove(store)
                    await store.handleSaveSkipLogicChanges()
                } else {
                    store.showSkipLogic = false
                }
            } else {
                await skipLogic.save(store)

                await store.handleSaveSkipLogicChanges()
            }
        } catch (error) {
            console.error('Error saving skip logic:', error)
        } finally {
            setTimeout(() => {
                this.saving = false
            }, 1000)
        }
    }

    changeSkipGroup = (index) => {
        console.log(`changeSkipGroup ${index}`)
        this.activeGroupIndex = index
    }

    addSkipOption = ({ setY, pageQuestionId, setX }) => {
        const { store } = this.props
        const { skipLogic } = this
        console.log('addSkipOption')
        console.log(this.existing_options)
        console.log(setY)
        console.log(pageQuestionId)
        console.log(setX)

        console.log(skipLogic.triggerGroups)
        console.log(this.activeGroupIndex)
        const inheritedPageQuestionId = setX ? setX.parentId : setY.parentId
        skipLogic.triggerGroups[this.activeGroupIndex].addCondition(setY, pageQuestionId, setX, inheritedPageQuestionId)
        console.log(JSON.stringify(skipLogic, null, 4))
        store.handleUnsavedSkipLogicChanges()
    }

    getExistingOptions = () => {
        const { skipLogic } = this
        const existingOptions = observable.map({})
        console.log(JSON.stringify(skipLogic, null, 4))
        if (skipLogic.triggerGroups.length < this.activeGroupIndex) {
            this.activeGroupIndex = 0
        }

        const triggerGroup = skipLogic.triggerGroups[this.activeGroupIndex]

        if (R.pathOr([], ['children'], triggerGroup)) {
            triggerGroup.children.forEach((child) => {
                if (child.triggers) {
                    child.triggers.forEach((trigger) => {
                        const { kind, set1, set2 } = trigger.condition
                        let option = ''

                        if (['QuestionExistsInSurveyResponse', 'QuestionHasNumericResponse'].includes(kind)) {
                            option = trigger.condition.pageQuestionId
                        } else {
                            option = set1
                            if (set2) {
                                option += `|${set2}`
                            }
                        }

                        console.log(option)
                        existingOptions.set(option, true)
                    })
                }
            })
        }

        return existingOptions
    }

    addSurveyDateOption = (surveyField) => {
        const { skipLogic } = this
        skipLogic.triggerGroups[this.activeGroupIndex].addSurveyDateCondition(surveyField)
    }

    addHasResponseOption = ({ pageQuestionId, setY }) => {
        const { skipLogic } = this
        console.log('addHasResponseOption')
        skipLogic.triggerGroups[this.activeGroupIndex].addHasResponseCondition(pageQuestionId, setY)
    }

    addNumericOption = ({ pageQuestionId, equalityOperator, value, setY }) => {
        const { skipLogic } = this
        console.log('addNumericOption')
        skipLogic.triggerGroups[this.activeGroupIndex]
            .addNumericCondition(pageQuestionId, equalityOperator, value, setY)
    }

    getQuestionOptions = (page, isSamePage) => {
        const { question, store } = this.props
        const options = page.questions.map((page_question, index) => {
            const pageQuestion = page_question
            const isMultiChoiceQuestionAndIsNotHidden = pageQuestion.question.isMulti()
                && (!pageQuestion.isHidden || pageQuestion.hasPopulateFrom)
            const { hasPrepopulatedData } = pageQuestion
            console.log('skipOption1', pageQuestion.question.questionTypeCode)
            if ((!isSamePage || !pageQuestion.hasPopulateFrom)
                && Object.hasOwnProperty.call(pageQuestion.question, 'questionTypeCode')
                && pageQuestion.questionType() !== 'OD'
                && (['SB', 'TA', 'TX', 'TL', 'I', 'UV'].includes(pageQuestion.question.questionTypeCode) || isMultiChoiceQuestionAndIsNotHidden || hasPrepopulatedData)
            ) {
                if (isSamePage && page.questions.map((pq) => pq.id).indexOf(store.skipLogicConfig.question.id) <= index) return
                console.log('skipOption', pageQuestion.question.questionTypeCode)
                const id = `test_${pageQuestion.questionId}_option_${index}`
                return (
                    <SkipOption
                        store={store}
                        getExistingOptions={this.getExistingOptions}
                        addSkipOption={this.addSkipOption}
                        addHasResponseOption={this.addHasResponseOption}
                        addNumericOption={this.addNumericOption}
                        key={id}
                        page_question={pageQuestion}
                        question={question}
                        question_index={index}
                        page={page}
                    />
                )
            }
        })
        return [...options]
    }

    toggleOptions = (index) => {
        this.showOptions.forEach((value, key) => {
            if (key !== index) {
                this.showOptions.set(key, false)
            }
        })
        this.showOptions.set(index, !this.showOptions.get(index))
        console.log(`toggleOptions ${this.showOptions.get(index)}`)
    }

    togglePrevPages = () => {
        this.prevPagesOpen = !this.prevPagesOpen
    }

    toggleOtherValues = () => {
        this.otherValuesOpen = !this.otherValuesOpen
    }

    deleteAll = async () => {
        const { store } = this.props
        const { skipLogicConfig } = store

        try {
            if (skipLogicConfig.onSave) {
                await skipLogicConfig.onSave(store, [])
            }
            await this.skipLogic.remove(store)
        } catch (e) {
            console.log(`Error deleting skiplogic: ${e}`)
        } finally {
            this.setDefaultLogic()
            this.closeDeleteAllModal()
        }
    }

    removeSkipGroup = (index, e) => {
        e.preventDefault()
        const { store } = this.props
        const { skipLogicConfig } = store
        const { skipLogic } = this
        console.log(`removeSkipGroup ${index}`)
        if (skipLogicConfig.type === 'option') {
            this.questionLogic = this.questionLogic.splice(index, 1)
            skipLogic.removeTriggerGroup(index)
        } else {
            skipLogic.removeTriggerGroup(index)
        }
        this.activeGroupIndex = 0
        store.handleUnsavedSkipLogicChanges()
        e.stopPropagation()
    }

    changeTriggerOperator = (groupIndex, childIndex, value) => {
        const { store } = this.props
        const { skipLogic } = this
        console.log(`changeTriggerOperator ${groupIndex}`)
        skipLogic.changeTriggerOperator(groupIndex, childIndex, value)
        store.handleUnsavedSkipLogicChanges()
    }

    updateTriggerGroupOperator = (groupIndex, childIndex, value) => {
        const { store } = this.props
        const { skipLogic } = this
        console.log(`updateTriggerGroupOperator ${groupIndex} ${childIndex}`)
        skipLogic.updateTriggerGroupOperator(groupIndex, childIndex, value)
        console.log(JSON.stringify(skipLogic, null, 4))
        store.handleUnsavedSkipLogicChanges()
    }

    updateGroupOperator = (groupIndex, obj) => {
        const { store } = this.props
        const { skipLogic } = this
        const { value } = obj
        console.log(`updateGroupOperator ${groupIndex}`)
        skipLogic.updateGroupOperator(groupIndex, value)
        console.log(JSON.stringify(skipLogic, null, 4))
        store.handleUnsavedSkipLogicChanges()
    }

    addSurveyQuotaOption = () => {
        const { store } = this.props
        const { skipLogic } = this
        console.log('addSurveyQuotaOption')
        skipLogic.triggerGroups[this.activeGroupIndex].addSurveyQuotaCondition()
        store.handleUnsavedSkipLogicChanges()
    }

    addSurveyDateOption = (surveyField) => {
        const { store } = this.props
        const { skipLogic } = this
        console.log('addSurveyDateOption', skipLogic.triggerGroups[this.activeGroupIndex])
        skipLogic.triggerGroups[this.activeGroupIndex].addSurveyDateCondition(surveyField)
        store.handleUnsavedSkipLogicChanges()
    }

    surveyDates = () => {
        const { skipLogic } = this
        const { activeGroupIndex } = this

        /**
         * Date SkipLogic should only be available for ExploriAdmins
         * and PE / EM surveys
         */
        // if (!store.isExploriAdmin() || !['PE', 'EM'].includes(surveyType)) {
        //     return null
        // }

        const triggerGroup = R.pathOr([], ['triggerGroups', activeGroupIndex], skipLogic)
        const dateTriggers = R.pathOr([], ['children'], triggerGroup).map(({ triggers }) => (
            triggers
                .filter(({ condition }) => condition.kind === 'Date')
                .map(({ condition }) => condition.dateField)
        )).flat(2)

        const dateFields = ['startDate', 'endDate']
            .filter((field) => !dateTriggers.includes(field))

        return dateFields.map((field) => (
            <div className="question_option" style={{ marginBottom: 5 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    {i18n.t(`s_skiplogic_${field}`)}

                    <i
                        className="fal fa-circle-plus"
                        onClick={() => this.addSurveyDateOption(field)}
                    />
                </div>
            </div>
        ))
    }

    addSkipGroup() {
        const { store } = this.props
        this.skipLogic.addGroup()
        this.activeGroupIndex = R.pathOr([], ['skipLogic', 'triggerGroups'], this).length - 1
        store.handleUnsavedSkipLogicChanges()
    }

    getTitle = (type) => {
        switch (type) {
            case 'page':
                return 'Page'
            case 'question':
                return 'Question'
            case 'option':
                return 'Option'
            default:
                return ''
        }
    }

    previousGroupsHaveLogic = () => {
        const { skipLogic, activeGroupIndex } = this

        return skipLogic.triggerGroups.map((sl, i) => {
            if (i <= activeGroupIndex) {
                return !!sl.children.length
            }

            return false
        }).some((val) => val)
    }

    render() {
        const {
            pages,
            store,
            history,
        } = this.props
        const { skipLogicConfig } = store
        const prevPages = pages.map((page, index) => {
            const id = `skiplogic_page_${index}`
            if (
                (index < skipLogicConfig.pageIndex && page.pageType === 'ST')
                || (index === skipLogicConfig.pageIndex && skipLogicConfig.questionIndex)
            ) {
                const options = this.getQuestionOptions(
                    page, (index === skipLogicConfig.pageIndex), skipLogicConfig.questionIndex,
                )
                const optionsComponent = options.length > 0 ? options : (
                    <div className="no-options">
                        <b>{i18n.t('skipLogicModal.noQuestionsAvailable')}</b>
                    </div>
                )

                return (
                    <div className="skip_page" style={{ backgroundColor: '#F7F8FA' }} id={id}>
                        <div
                            className="skip-options-group"
                            onClick={() => this.toggleOptions(index)}
                        >
                            <i className={`fal fa-chevron-${this.showOptions.get(index) ? 'up' : 'down'}`} />

                            <p style={{ fontWeight: 'bold' }}>{`Page ${page.priority}`}</p>

                            <p>{page.title}</p>
                        </div>

                        {this.showOptions.get(index) && optionsComponent}

                    </div>
                )
            }
        })

        const groups = R.pathOr([], ['skipLogic', 'triggerGroups'], this).map((group, index) => {
            const id = `skiplogic_group_${index}`
            return (
                <Fragment>
                    {index > 0
                        ? (
                            <Select
                                classNamePrefix="dropdown"
                                className="exploriDropdown"
                                label={i18n.t('skipLogicModal.function')}
                                defaultValue={R.pathOr('AND', ['interGroupLogicalOperator'], group)}
                                options={SkipLogicOperators}
                                onBlur={(obj) => this.updateGroupOperator(index, obj)}
                            />
                        ) : null}
                    <SkipSelection
                        store={store}
                        // origQuestion={question}
                        group={group}
                        key={id}
                        changeSkipGroup={this.changeSkipGroup}
                        removeSkipGroup={this.removeSkipGroup}
                        changeTriggerOperator={this.changeTriggerOperator}
                        updateTriggerGroupOperator={this.updateTriggerGroupOperator}
                        index={index}
                        activeGroupIndex={this.activeGroupIndex}
                    />
                </Fragment>
            )
        })

        const skipLogicType = this.getTitle(skipLogicConfig.type)
        const hasPrevPagesAvailable = prevPages.filter((p) => p !== undefined).length > 0

        return (
            <div className="display-skip-logic-container">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 20, width: '40%' }}>
                    <Panel cssClass="display-skip-logic-left-container">
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center', cursor: 'pointer' }} onClick={this.togglePrevPages}>
                            <i className={`fal fa-chevron-${this.prevPagesOpen ? 'up' : 'down'}`} />

                            <h4>{i18n.t('q2qskip_prevpages')}</h4>
                        </div>

                        <div
                            id="leftSkip"
                            style={{
                                display: this.prevPagesOpen ? 'block' : 'none',
                                maxHeight: 400,
                                overflowY: hasPrevPagesAvailable ? 'scroll' : 'hidden',
                            }}
                        >
                            {hasPrevPagesAvailable
                                ? prevPages
                                : (
                                    <div className="no-options">
                                        <b>{i18n.t('skipLogicModal.noOptionsAvailable')}</b>
                                    </div>
                                )}
                        </div>
                    </Panel>

                    <Panel cssClass="display-skip-logic-left-container">
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center', cursor: 'pointer' }} onClick={this.toggleOtherValues}>
                            <i className={`fal fa-chevron-${this.otherValuesOpen ? 'up' : 'down'}`} />

                            <h4>{i18n.t('skipLogicModal.otherValues')}</h4>
                        </div>

                        <div id="leftSkip" style={{ maxHeight: 400, overflowY: 'scroll', backgroundColor: 'rgb(247, 248, 250)', padding: '10px 12px', display: this.otherValuesOpen ? 'block' : 'none' }}>
                            {this.surveyDates()}
                        </div>
                    </Panel>
                </div>

                <Panel cssClass="display-skip-logic-right-container">
                    <div className="display-skip-logic-right-container-title">
                        <p>
                            {skipLogicType}
                            <p className="display-skip-logic-right-container-highlight">{skipLogicConfig.title}</p>
                            {i18n.t('skipLogicModal.will')}
                            <p className="display-skip-logic-right-container-highlight">{i18n.t('skipLogicModal.show')}</p>
                        </p>
                    </div>

                    <br />

                    <div className="display-skip-logic-right-container-groups">
                        {groups}
                    </div>

                    <br />

                    <div className="display-skip-logic-right-container-button-row">
                        <div>
                            {this.previousGroupsHaveLogic() && this.hadExistingLogic
                                ? (
                                    <Button
                                        icon="fal fa-circle-xmark"
                                        label={i18n.t('skipLogicModal.deleteLogic')}
                                        cssClass="regular error"
                                        onClick={this.openDeleteAllModal}
                                    />
                                ) : null}
                        </div>

                        <div className="right-floating-buttons">
                            <Button
                                icon="fal fa-circle-plus"
                                label={i18n.t('skipLogicModal.addNewRule')}
                                cssClass="regular primary"
                                onClick={this.addSkipGroup}
                                disabled={!this.previousGroupsHaveLogic()}
                            />

                            <Button
                                icon="fal fa-save"
                                label={i18n.t('skipLogicModal.saveLogic')}
                                cssClass="regular primary"
                                disabled={this.saving}
                                onClick={() => this.save(
                                    pages[skipLogicConfig.pageIndex], store.survey, history,
                                )}
                            />
                        </div>
                    </div>
                </Panel>

                <Modal
                    show={this.deleteAllModalOpen}
                    onClose={this.closeDeleteAllModal}
                >
                    <ModalHeader>
                        <div style={{ textAlign: 'center' }}>
                            <h3>
                                {i18n.t('deleteAllLogicModal.title')}
                            </h3>

                            <br />

                            <p>
                                {i18n.t('deleteAllLogicModal.body')}
                            </p>
                        </div>
                    </ModalHeader>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
                        <Button
                            cssClass="regular tertiary"
                            onClick={this.closeDeleteAllModal}
                            label={i18n.t('cancel')}
                        />

                        <Button
                            cssClass="regular primary"
                            onClick={this.deleteAll}
                            label={i18n.t('deleteAllLogicModal.confirm')}
                        />
                    </div>
                </Modal>
            </div>
        )
    }
}

export default SkipDisplayLogic
